import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Show } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { ThemeProvider } from "@/context/ThemeContext";
import { HubProvider } from "@/hub/HubContext";
import { Toaster } from "@/components/ui/sonner";
import { Protected } from "@/components/auth/Protected";
import Landing from "@/pages/Landing";
import SignInPage from "@/pages/SignInPage";
import SignUpPage from "@/pages/SignUpPage";
import Dashboard from "@/pages/Dashboard";
import Project from "@/pages/Project";
import FirmwareGuide from "@/pages/FirmwareGuide";
import ClassroomGuide from "@/pages/ClassroomGuide";
import HowItWorks from "@/pages/HowItWorks";
import Compatibility from "@/pages/Compatibility";
import GuestProject from "@/pages/GuestProject";
import Admin from "@/pages/Admin";
import { MeProvider } from "@/context/MeContext";

const Home = () => (
  <>
    <Show when="signed-in"><Navigate to="/projects" replace /></Show>
    <Show when="signed-out"><Landing /></Show>
  </>
);

const Try = () => (
  <>
    <Show when="signed-in"><Navigate to="/projects?setup=new" replace /></Show>
    <Show when="signed-out"><GuestProject /></Show>
  </>
);

// Links saved before projects replaced programs.
const OldProjectLink = () => <Navigate to={`/projects/${useParams().id}`} replace />;

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <ClerkAuthProvider>
            <MeProvider>
            <HubProvider>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/sign-in/*" element={<SignInPage />} />
                <Route path="/sign-up/*" element={<SignUpPage />} />
                <Route path="/projects" element={<Protected><Dashboard /></Protected>} />
                <Route path="/projects/:id" element={<Protected><Project /></Protected>} />
                <Route path="/admin" element={<Protected><Admin /></Protected>} />
                <Route path="/programs" element={<Navigate to="/projects" replace />} />
                <Route path="/editor/:id" element={<OldProjectLink />} />
                <Route path="/try" element={<Try />} />
                <Route path="/firmware" element={<FirmwareGuide />} />
                <Route path="/classroom" element={<ClassroomGuide />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/compatibility" element={<Compatibility />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Toaster position="bottom-right" richColors closeButton />
            </HubProvider>
            </MeProvider>
          </ClerkAuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
